import React from 'react'
import { Link } from 'react-router-dom'

const PageNoFound = () => {
    return (
        <div className="container">
            <h1>Page no found</h1>
            <Link to="/" className="btn btn-danger">Home</Link>
        </div>
    )
}

export default PageNoFound
